<i18n src="./../../i18n/contact_thanks.json"></i18n>

<template>
    <div id="contact-thanks-page">
        <vue-headful
                :title="$t('pageTitle')"
                :description="$t('pageDescription')"
                :url="pageUrl"/>
        <navigation-bar/>

        <div id="paralax-subpage-section" class="lazy jumbotron mt-page-nav-image" data-bg="/assets/mt-cart-header-image.jpg">
            <div class="container">
                <p class="display-1 mt-f-regular par-text-1" style="opacity: 0.5;" v-text="$t('order')" />
            </div>
        </div>

        <div class="container-fluid mt-subpage-section m-0 p-0">
            <div class="container-fluid m-0 p-0">
                <div class="lazy container-fluid">

                    <div class="container">
                        <div class="content-container p-3 pt-5">
                            <div class="row">
                                <div class="col-lg-3"></div>
                                <div class="col-lg-9 pt-2 pl-4">
                                    <img data-src="/assets/mt-email-sent.png" alt="sent" class="lazy pt-5"><br>
                                    <h1 class="pt-2 pb-0" v-text="$t('thanks')" />
                                    <h2 class="pb-0" v-text="$t('orderSent')" />
                                    <h5 class="pt-4 pb-0" v-text="$t('emailSentInfo')" />
                                    <br>
                                    <br>
                                    <router-link :to="{name: 'home'}" v-text="$t('mainPageInfo')" />
                                </div>
                            </div>
                        </div>

                        <main-footer/>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import MainFooter from "@/components/commons/MainFooter";
    import NavigationBar from "@/components/commons/NavigationBar";
    import {Const} from "@/main";
    import LazyLoad from "vanilla-lazyload";

    var lazyLoadInstance = new LazyLoad({
        elements_selector: ".lazy"
    });

    export default {
        name: "ContactThanks",
        components: {NavigationBar, MainFooter},
        data () {
            return {
                pageUrl: Const.HOST + this.$route.path
            }
        },
        mounted() {
            this.$nextTick(() => {
                lazyLoadInstance.update()
            })
        }
    }
</script>

<style scoped>
    #paralax-subpage-section {
        height: 200px;
    }
</style>